(function () {
  var pdpGalleryState = new WeakMap();
  var previousViewportIsMobile = isMobileExperimentViewport();

  function getExperimentVariant(root) {
    var candidates = [root, document.body, document.documentElement];
    for (var i = 0; i < candidates.length; i += 1) {
      var node = candidates[i];
      if (!node) continue;
      var value = node.getAttribute('data-pdp-exp');
      if (value) return value;
    }
    return 'control';
  }

  function isMobileExperimentViewport() {
    return window.innerWidth < 750;
  }

  function getRootGalleryState(root) {
    var state = pdpGalleryState.get(root);
    if (!state) {
      state = {
        initialized: false,
        interacted: false,
        bound: false
      };
      pdpGalleryState.set(root, state);
    }
    return state;
  }

  function bindGalleryInteractionLock(root, state) {
    if (state.bound) return;
    state.bound = true;

    root.querySelectorAll('media-gallery .slider-button--next, media-gallery .slider-button--prev').forEach(function (button) {
      button.addEventListener('click', function () {
        state.interacted = true;
      });
    });
  }

  function resetMobileGalleryPages(root) {
    if (!isMobileExperimentViewport()) return;
    var state = getRootGalleryState(root);
    bindGalleryInteractionLock(root, state);
    var forceFirstPage = !state.interacted;

    root.querySelectorAll('media-gallery').forEach(function (mediaGallery) {
      var viewer = mediaGallery.querySelector('[id^="GalleryViewer"]');
      if (!viewer || typeof viewer.resetPages !== 'function') return;

      viewer.resetPages();

      if (viewer.sliderItemsToShow && viewer.sliderItemsToShow.length > 1 && (!viewer.slidesPerPage || viewer.slidesPerPage < 1)) {
        viewer.slidesPerPage = 1;
        viewer.totalPages = viewer.sliderItemsToShow.length;
      }

      if (forceFirstPage && !state.initialized) {
        state.initialized = true;
        if (viewer.sliderItemsToShow && viewer.sliderItemsToShow[0] && viewer.slider) {
          if (typeof viewer.slider.scrollTo === 'function') {
            viewer.slider.scrollTo({ left: viewer.sliderItemsToShow[0].offsetLeft });
          } else {
            viewer.slider.scrollLeft = viewer.sliderItemsToShow[0].offsetLeft;
          }
        }
      }

      if (typeof viewer.update === 'function') viewer.update();

      if (forceFirstPage) {
        viewer.currentPage = 1;
        if (typeof viewer.update === 'function') viewer.update();
      } else if (viewer.sliderItemsToShow && viewer.sliderItemsToShow.length > 0) {
        var currentPage = Number(viewer.currentPage) || 1;
        if (currentPage < 1) currentPage = 1;
        if (currentPage > viewer.sliderItemsToShow.length) currentPage = viewer.sliderItemsToShow.length;
        viewer.currentPage = currentPage;
      }

      if (!mediaGallery.elements || !mediaGallery.elements.thumbnails) return;

      var activeIndex = forceFirstPage ? 0 : (Number(viewer.currentPage) - 1);
      var currentSlide = viewer.sliderItemsToShow && viewer.sliderItemsToShow[activeIndex];
      if (!currentSlide && viewer.sliderItemsToShow && viewer.sliderItemsToShow.length > 0) {
        currentSlide = viewer.sliderItemsToShow[0];
      }
      if (!currentSlide || !currentSlide.dataset.mediaId || typeof mediaGallery.setActiveThumbnail !== 'function') return;
      var currentThumbnail = mediaGallery.elements.thumbnails.querySelector('[data-target="' + currentSlide.dataset.mediaId + '"]');
      mediaGallery.setActiveThumbnail(currentThumbnail);
    });
  }

  function scheduleMobileGalleryReset(root) {
    if (!isMobileExperimentViewport()) return;

    window.requestAnimationFrame(function () {
      resetMobileGalleryPages(root);
    });

    window.setTimeout(function () {
      resetMobileGalleryPages(root);
    }, 150);
  }

  function buildV1CtaRow(root) {
    if (window.innerWidth <= 749) return; // sticky bar handles mobile ATC
    if (root.querySelector('.qty-atc-row')) return;

    var quantity = root.querySelector('.pdp-block--quantity');
    var buyButtons = root.querySelector('.pdp-block--buy-buttons');
    if (!quantity || !buyButtons) return;

    var row = document.createElement('div');
    row.className = 'qty-atc-row pdp-v1-only';
    buyButtons.parentNode.insertBefore(row, buyButtons);
    row.appendChild(quantity);
    row.appendChild(buyButtons);
  }

  function selectDefaultPackSizeCard(root) {
    var cardInputs = Array.prototype.slice.call(root.querySelectorAll('.pack-size-picker__input:not(.disabled)'));
    if (!cardInputs.length) return;

    var selected = null;
    var selectedCount = -1;
    var fallback = root.querySelector('.pack-size-picker__input:not(.disabled)');

    cardInputs.forEach(function (input) {
      var match = /(\d+)/.exec(input.value || '');
      var count = match ? parseInt(match[1], 10) : NaN;

      if (!isNaN(count) && count > selectedCount) {
        selectedCount = count;
        selected = input;
      }
    });

    if (!selected) selected = fallback;
    if (!selected) return;

    if (selected.checked) return;

    selected.checked = true;
    selected.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function applyPdpVariant(root) {
    if (root.getAttribute('data-pdp-default-template') !== 'true') return;

    var isV1 = getExperimentVariant(root) === 'v1' && isMobileExperimentViewport();
    root.classList.toggle('pdp-exp--v1', isV1);

    scheduleMobileGalleryReset(root);

    if (!isV1) return;

    buildV1CtaRow(root);
    // Defer until after Dawn's variant-selects.js has initialised and may have
    // cleared the Liquid-rendered checked state due to shared radio name groups.
    setTimeout(function () { selectDefaultPackSizeCard(root); }, 0);
  }

  function syncAll() {
    document.querySelectorAll('[data-pdp-root][data-pdp-default-template="true"]').forEach(applyPdpVariant);
  }

  var observer = new MutationObserver(syncAll);
  var resizeTimer;

  function handleResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      var isMobileNow = isMobileExperimentViewport();
      if (isMobileNow === previousViewportIsMobile) return;
      previousViewportIsMobile = isMobileNow;
      syncAll();
    }, 150);
  }

  function start() {
    syncAll();
    if (document.body) {
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['data-pdp-exp'],
        subtree: false
      });
    }
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-pdp-exp']
    });
    window.addEventListener('resize', handleResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
